import { http } from '../config';
import {
  FORGOT_PASSWORD_CHECKING_ENDPOINT,
  FORGOT_PASSWORD_ENDPOINT,
  LOGIN_ENDPOINT,
  LOGOUT_ENDPOINT,
  NEW_PASSWORD_ENDPOINT,
  REGISTER_ENDPOINT,
} from '../endpoints';
import {
  ForgotPasswordRequest,
  InvitationCheckingRequest,
  LoginRequest,
  LoginResponse,
  NewPasswordRequest,
  RegisterRequest,
  SuccessResponse,
} from '../types';

export async function postForgotPassword(
  body: ForgotPasswordRequest
): Promise<SuccessResponse> {
  return http.put(FORGOT_PASSWORD_ENDPOINT, body, {
    skipAuthRefresh: true,
    withCredentials: false,
  });
}

export async function postNewPassword(
  body: NewPasswordRequest
): Promise<SuccessResponse> {
  return http.put(NEW_PASSWORD_ENDPOINT, body, {
    skipAuthRefresh: true,
    withCredentials: false,
  });
}

export async function postForgotPasswordChecking(
  body: InvitationCheckingRequest
): Promise<SuccessResponse> {
  return http.put(FORGOT_PASSWORD_CHECKING_ENDPOINT, body, {
    skipAuthRefresh: true,
    withCredentials: false,
  });
}

export async function postLogin(body: LoginRequest): Promise<LoginResponse> {
  return http.put(LOGIN_ENDPOINT, body, {
    skipAuthRefresh: true,
  });
}

export async function getLogout(): Promise<SuccessResponse> {
  return http.get(LOGOUT_ENDPOINT, {
    skipAuthRefresh: true,
  });
}

export async function postRegister(
  body: RegisterRequest
): Promise<LoginResponse> {
  return http.put(REGISTER_ENDPOINT, body);
}
